import { FleetCategory } from '../enums/fleet-category';

export const VEHICLE_CATEGORIES = [
  FleetCategory.SEMI_TRUCK,
  FleetCategory.STRAIGHT_TRUCK,
  FleetCategory.VAN,
] as const;

export type VehicleCategory = (typeof VEHICLE_CATEGORIES)[number];
